import React from "react";
import { Link } from "react-router-dom";
import { FiArrowRight } from "react-icons/fi";
import Frame from "../chrome/Frame";
import Meta from "../chrome/Meta";

const NotFound = () => (
  <Frame>
    <Meta title="Not found" />
    <div className="lost">
      <div>
        <div className="fig">404</div>
        <h2>This page wandered off.</h2>
        <p style={{ color: "#64748b", maxWidth: 480, margin: "0 auto 2rem" }}>
          The page you were looking for has either moved or was never published.
        </p>
        <Link to="/" className="btn btn--cobalt">Back to home <FiArrowRight /></Link>
      </div>
    </div>
  </Frame>
);

export default NotFound;
